import { createContext, useContext, useState, useEffect, useMemo, type ReactNode } from 'react';
import { fetchOrganizaciones, type OrganizacionResumen } from '../modules/shared/services/api';

interface OrganizacionContextValue {
  organizaciones: OrganizacionResumen[];
  selectedOrgId: string;
  setSelectedOrgId: (id: string) => void;
  loading: boolean;
}

const OrganizacionContext = createContext<OrganizacionContextValue>({
  organizaciones: [],
  selectedOrgId: '',
  setSelectedOrgId: () => {},
  loading: true,
});

export function useOrganizacion() {
  return useContext(OrganizacionContext);
}

export function OrganizacionProvider({ children }: { children: ReactNode }) {
  const [organizaciones, setOrganizaciones] = useState<OrganizacionResumen[]>([]);
  const [selectedOrgId, setSelectedOrgId] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrganizaciones()
      .then((r) => {
        const orgs = r.data;
        setOrganizaciones(orgs);
        // Auto-select first org if only one exists
        if (orgs.length === 1) setSelectedOrgId(orgs[0].id);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const value = useMemo(
    () => ({
      organizaciones,
      selectedOrgId,
      setSelectedOrgId,
      loading,
    }),
    [organizaciones, selectedOrgId, loading],
  );

  return <OrganizacionContext.Provider value={value}>{children}</OrganizacionContext.Provider>;
}
